/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
// 验证外部链接
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证权限
export function validUsername(str) {
    const valid_map = ['admin', 'editor']
    return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
// 验证url
export function validURL(url) {
    const reg =
        /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证数字
export function validNumber(str) {
    const reg = /^[0-9]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证小写字母
export function validLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证大写字母
export function validUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证字母
export function validAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证字母数字
export function validWordNum(str) {
    const reg = /^[A-Za-z0-9]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证中文字母数字
export function validName(str) {
    const reg = /^[\u4e00-\u9fffa-zA-Z0-9]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证密码
export function validPassword(str) {
    const reg = /^[a-zA-Z0-9!@#$%^&*]+$/
    return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证车牌号
export function validCarNum(str) {
    // /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
    const reg = /^[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
    return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
// 验证email
export function validEmail(email) {
    const reg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(email)
}

/**
 * @param {string} val
 * @returns {Boolean}
 */
// 验证手机号
export function checkPhone(val) {
    if (!/^1[3456789]\d{9}$/.test(val)) {
        return false
    }
    return true
}

/**
 * @param {string} val
 * @returns {Boolean}
 */
// 验证身份证号
export function checkID(val) {
    // var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    var reg =
        /(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/
    if (!reg.test(val)) {
        return false
    }
    return true
}

/**
 * @param {string, number} val
 * @returns {Boolean}
 */
// 验证是否为数字
export function isNumber(val) {
    if (parseFloat(val).toString() == 'NaN') {
        return false
    } else {
        return true
    }
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 验证是否为字符串
export function isString(str) {
    if (typeof str === 'string' || str instanceof String) {
        return true
    }
    return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
// 判断是否含是数组
export function isArray(arg) {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 判断是否含有中文
export function isHasChinese(str) {
    let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
    if (reg.test(str)) {
        return true
    } else {
        return false
    }
}

/**
 * @param {string} a
 * @param {object} obj
 * @returns {Boolean}
 */
// 判断数组中是否包含某个对象
export function contains(a, obj) {
    for (var i = 0; i < a.length; i++) {
        if (a[i].id === obj.id) {
            return true
        }
    }
    return false
}

/**
 * @param {string} str
 * @returns {number}
 */
// 获取字符串字符长度
export function strlen(str) {
    var len = 0
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i)
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++
        } else {
            len += 2
            // len++ //中文算一个字符
        }
    }
    return len
}

export const limitSmall = 20
export const limitMiddle = 200
export const limitLarge = 500

export function validatorUser(rule,value,callback) {
    if(validWordNum(value)) {
        callback();
    }else {
        callback(new Error("用户名输入错误"));
    }
}
export function validatorPassWord(rule,value,callback) {
    if(validWordNum(value)) {
        callback();
    }else {
        callback(new Error("密码输入错误"));
    }
}
